module.exports = __webpack_public_path__ + "media/site_templates/www.gascooktopinstallation.com.au/images/testimonials-b4749335ab0f975d5fdf1cbeb96bc92e.jpg";